export default {
  setDump(state, dump) {
    state.dump = dump
  }
}
